import { Outlet, createFileRoute, redirect } from '@tanstack/react-router'
import { useCurrentRouteId } from '../../../hooks'
import type { ComponentProps } from 'react'
import { Page } from '~/components'
import { getQueryOptions } from '~/services'
import { isAuthorized } from '~/features/users/services/permissions'

export const Route = createFileRoute('/workspaces/$workspaceId/billing')({
  beforeLoad: async ({ context, params }) => {
    const members = await context.queryClient.ensureQueryData(
      getQueryOptions('workspaces_/$workspaceId_/members', { workspaceId: params.workspaceId })
    )
    const workspaceMember = members?.find((member) => member.userId === context.user.id)

    if (
      !workspaceMember ||
      !isAuthorized({
        permission: 'workspace.manageBilling',
        role: workspaceMember.role,
      })
    ) {
      throw redirect({
        to: '/forbidden',
        search: { workspaceId: params.workspaceId },
      })
    }
  },
  component: Component,
})

function Component() {
  const currentRouteId = useCurrentRouteId() ?? ''

  const items: ComponentProps<typeof Page>['navbarItems'] = [
    {
      children: 'Summary',
      to: '/workspaces/$workspaceId/billing/summary',
    },
    {
      children: 'Add-ons',
      to: '/workspaces/$workspaceId/billing/add-ons',
    },
    {
      children: 'Plans',
      to: '/workspaces/$workspaceId/billing/plans',
    },
  ]

  const itemsWithActiveState = items.map((i) => ({
    ...i,
    active: currentRouteId.includes(i?.to ?? 'not-a-path'),
  }))

  return (
    <Page title="Billing" navbarItems={itemsWithActiveState}>
      <Outlet />
    </Page>
  )
}
